var _rect, _path, _rect2, _rect3, _path2, _rect4, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWordPrdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 88,
    viewBox: "0 0 100 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    width: 75,
    height: 87.5,
    rx: 2,
    fill: "url(#paint0_linear_2919_127)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 65.625H100V85.5C100 86.6046 99.1046 87.5 98 87.5H27C25.8954 87.5 25 86.6046 25 85.5V65.625Z",
    fill: "url(#paint1_linear_2919_127)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 43.75,
    width: 75,
    height: 21.875,
    fill: "url(#paint2_linear_2919_127)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 21.875,
    width: 75,
    height: 21.875,
    fill: "url(#paint3_linear_2919_127)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.875C25 23.2181 26.3431 21.875 28 21.875H59.5C61.1569 21.875 62.5 23.2181 62.5 24.875V75.125C62.5 76.7819 61.1569 78.125 59.5 78.125H25V24.875Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 15.625,
    width: 56.25,
    height: 56.25,
    rx: 2,
    fill: "url(#paint4_linear_2919_127)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 28.1693H40.7884L36.009 48.5594L30.7802 28.125H25.6332L20.3636 48.5594L15.625 28.1693H9.375L17.5041 59.375H22.8962L28.125 39.6498L33.3538 59.375H38.7459L46.875 28.1693Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2919_127",
    x1: 25,
    y1: 14.5833,
    x2: 100,
    y2: 14.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2919_127",
    x1: 25,
    y1: 79.2969,
    x2: 100,
    y2: 79.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2919_127",
    x1: 57.8125,
    y1: 56.25,
    x2: 100,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20478B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6FD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2919_127",
    x1: 57.8125,
    y1: 34.375,
    x2: 100,
    y2: 34.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E84D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2919_127",
    x1: 1.0348e-7,
    y1: 46.875,
    x2: 59.375,
    y2: 46.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215091"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordPrdct);
export default __webpack_public_path__ + "static/media/word-prdct.6fd2331d2d3c43ac3208d4a53b75c11f.svg";
export { ForwardRef as ReactComponent };